import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { NgClass } from '@angular/common';

type PerioFormToothButtonType = 'back' | 'next' | 'up' | 'down';

@Component({
  selector: 'lib-perio-form-tooth-navigator-button',
  imports: [SvgIconComponent, NgClass],
  templateUrl: './perio-form-tooth-navigator-button.component.html',
  styleUrl: './perio-form-tooth-navigator-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class PerioFormToothNavigatorButtonComponent {
  public type = input.required<PerioFormToothButtonType>();
  public isDisabled = input<boolean>(false);
  public buttonClick = output<void>();

  protected iconKey = computed(() => {
    switch (this.type()) {
      case 'back': {
        return 'px-16-chevron-left';
      }
      case 'next': {
        return 'px-16-chevron-right';
      }
      case 'up': {
        return 'px-16-chevron-up';
      }
      case 'down': {
        return 'px-16-chevron-down';
      }
    }
  });
  protected disabledClass = computed(() => (this.isDisabled() ? '!text-background-disabled' : ''));

  protected onButtonClick(): void {
    this.buttonClick.emit();
  }
}
